import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["aria-label", "aria-live", "variant", "size", "className"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import styles from './loading-indicator.module.js';

function LoadingIndicator(props) {
  var ariaLabel = props['aria-label'],
      _props$ariaLive = props['aria-live'],
      ariaLive = _props$ariaLive === void 0 ? 'polite' : _props$ariaLive,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      rest = _objectWithoutProperties(props, _excluded);

  return jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
    "aria-label": ariaLabel,
    "aria-live": ariaLive,
    className: clsx(styles.crawler, styles[variant], styles[size], className),
    role: "status",
    children: [jsx("div", {
      className: styles.segment
    }), jsx("div", {
      className: styles.segment
    }), jsx("div", {
      className: styles.segment
    })]
  }));
}

export { LoadingIndicator };